<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_amzStore') || '店铺'"
            prop="storeCode"
          >
            <dict-select
              :value="storeItem"
              :placeholder="$l('form_placeholder_amzStore') || '请选择店铺'"
              url="/ecom/amz/store/select"
              :options="{ label: 'label', value: 'this' }"
              filterable
              clearable
              @change="storeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_region') || '市场'">
            <el-input
              v-model="formData.regionName"
              :placeholder="$l('form_placeholder_amzStore') || '请选择店铺'"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-1">
        <SkuTable :tableData="skuTableData" ref="skuTable">
          <template v-slot:header>
            <div class="d-flex mt-2">
              <div class="side-frame-success">
                <span style="font-size: 14px; color: #606266">
                  {{
                    $l('table_header_cross_site_sales_sku') || '跨站点售卖SKU'
                  }}
                </span>
                <el-divider direction="vertical"></el-divider>
                <el-button size="mini" type="primary" plain @click="chooseSku">
                  {{ $l('btn_cross_site_sales_sku') || '选择跨站点售卖SKU' }}
                </el-button>
              </div>
            </div>
          </template>
        </SkuTable>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <ChooseAmzSotreSkuOnSale
      :visible.sync="chooseAmzSotreSkuOnSaleVisible"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseAmzSkuConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from './sku-table'
import ChooseAmzSotreSkuOnSale from '../choose-amz-sotreSku-onSale'
export default {
  mixins: [EditLoading],
  components: { SkuTable, ChooseAmzSotreSkuOnSale },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      chooseAmzSotreSkuOnSaleVisible: false,
      skuTableData: [],
      rules: {
        storeCode: [
          {
            required: true,
            message: this.$l('form_placeholder_amzStore') || '请选择店铺',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    storeItem() {
      const {
        regionCode,
        regionName,
        storeCode: value,
        storeName: label,
      } = this.formData
      return { regionCode, regionName, value, label }
    },
  },
  watch: {
    storeItem: {
      handler(newVal, oldVal) {
        const { value: newStoreCode } = newVal
        const { value: oldStoreCode } = oldVal
        if (newStoreCode === oldStoreCode) return
        if (!this.skuTableData || !this.skuTableData.length) return
        this.skuTableData = []
      },
    },
  },
  methods: {
    storeChange(e) {
      const { regionCode, regionName, value: storeCode, label: storeName } = e
      this.formData = {
        ...this.formData,
        regionCode,
        regionName,
        storeCode,
        storeName,
      }
    },
    async chooseSku() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false
      this.chooseAmzSotreSkuOnSaleVisible = true
    },
    chooseAmzSkuConfirm(e) {
      if (!e || !e.length) return

      // 过滤已经选择的SKU
      const old_data = this.$refs.skuTable.getTableData()
      const new_data = e.filter(
        (i) => old_data.findIndex((j) => i.amzSkuCode === j.amzSkuCode) < 0
      )

      old_data.push(...new_data)
      this.skuTableData = old_data
    },
    async putShelves() {
      if (!(await validate.formValidate([this.$refs.form])))
        return (this.backDialogVisible = false)

      const listSku = this.$refs.skuTable.getTableData()
      const params = { ...this.formData, listSku }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuCrossSiteSalesApi(params)
        .catch(() => null)
      this.loadingClose()

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error('跨站点售卖失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '跨站点售卖成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
